import React from 'react';

import { StyledDiv } from './NoProductsCardStyles';

var _ref = React.createElement(
  StyledDiv,
  null,
  React.createElement(
    'h3',
    null,
    'Oops!'
  ),
  React.createElement(
    'p',
    null,
    "Unfortunately we don't have anything exactly matching your filters, but broaden you search to see what else we've got and that may work!"
  )
);

var NoProductsCard = function NoProductsCard() {
  return _ref;
};

export default React.memo(NoProductsCard);